var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileBend = function SvgFileBend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.333 4.667v4.666A2.667 2.667 0 0 0 20 12h4.666m-14-8h5.563c.707 0 1.385.28 1.885.781l6.438 6.438c.5.5.781 1.178.781 1.886V24a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4"
  })));
};
export default SvgFileBend;